module.exports = __webpack_public_path__ + "img/vincent-colyer.1cf62c38.png";